import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import FAQ from "@/components/site/FAQ";
import LessIsMore from "@/components/site/LessIsMore";
import JoinTeam from "@/components/site/JoinTeam";
import Footer from "@/components/site/Footer";
import { trackPageview } from "@/lib/api";

const scrollToReserve = () => {
  const el = document.getElementById("reserve");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const PAGEVIEW_FLAG = "w_pv_sent";

export default function Landing() {
  useEffect(() => {
    // Once per browser session — survives hot reload, not full restarts.
    if (sessionStorage.getItem(PAGEVIEW_FLAG)) return;
    sessionStorage.setItem(PAGEVIEW_FLAG, "1");
    trackPageview(window.location.pathname, document.referrer || "");
  }, []);

  return (
    <main data-testid="landing-page" className="relative bg-obsidian text-pearl overflow-x-hidden">
      <Nav onReserveClick={scrollToReserve} />
      <Hero />
      <Features />
      <LessIsMore />
      <FAQ />
      <JoinTeam />
      <Footer />
    </main>
  );
}
